<template>
  <div class="md:container md:container-main flex">
    <nav class="w-full relative cursor-pointer group z-10 min-[1440px]:flex hidden">
      <ul class="flex items-center h-full w-full gap-6 justify-start mr-3 2xl:mr-0">
        <li
          v-for="{ name, titleKey } in navList"
          :key="name"
          class="border-background last:border-none hover:text-secondary"
        >
          <router-link
            class="text--md font-bold"
            :to="{
              name,
            }"
            active-class="text-primary-pressed"
          >
            {{ $t(titleKey) }}
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="flex items-center gap-2 justify-center">
      <HeaderCart />
      <HeaderProfilesList v-if="!isInFrame()" />
    </div>
  </div>
</template>

<script setup lang="ts">
import HeaderCart from "./HeaderCart.vue"
import HeaderProfilesList from "./HeaderProfilesList.vue"
import { isInFrame } from "@academy/utils"

const navList = [
  {
    name: "/programs",
    titleKey: "common.workshops",
  },
  {
    name: "/partnership",
    titleKey: "common.partners",
  },
  {
    name: "/investment-deck",
    titleKey: "common.investment-deck",
  },
  {
    name: "/franchising",
    titleKey: "common.franchising",
  },
  {
    name: "/about",
    titleKey: "common.about-us",
  },
  {
    name: "/contacts",
    titleKey: "common.contact-us",
  },
]

defineEmits({
  "open-partner-form": null,
})
</script>

<style lang="scss" scoped>
.nav-contacts {
  @media (max-width: 1024px) {
    display: none;
  }
}

.active {
  @apply text-primary-pressed;
}
</style>
